import 'css-chunksrc/client/scenes/documentCreation/form/templates/preview/docxRenderer/styles.scss';export default {
  "renderer": "_renderer_10a9l_1",
  "content": "_content_10a9l_11"
};